module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0005.jpg?v=fb0b3034";